"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactI18next = require("react-i18next");
var _store = require("../../redux/store");
var _CouponInput = _interopRequireDefault(require("../CouponInput"));
var _Payment = _interopRequireDefault(require("../Payment"));
var _Header = _interopRequireDefault(require("../Header"));
var _SectionHeader = _interopRequireDefault(require("../SectionHeader"));
var _Footer = _interopRequireDefault(require("../Footer"));
var _CheckoutPriceBox = _interopRequireDefault(require("../CheckoutPriceBox"));
var _FreeOffer = _interopRequireDefault(require("../FreeOffer"));
var _DeliveryDetails = _interopRequireDefault(require("../DeliveryDetails"));
var _orderSlice = require("../../redux/orderSlice");
var _offerSlice = require("../../redux/offerSlice");
var _OfferStyled = require("./OfferStyled");
var _OfferCheckoutCard = _interopRequireDefault(require("../OfferCheckoutCard"));
var _jsxRuntime = require("react/jsx-runtime");
const Offer = _ref => {
  let {
    isCheckout = false,
    onCouponSubmit,
    onPaymentComplete,
    onRedeemClick
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const [coupon, setCoupon] = (0, _react.useState)('');
  const {
    isCouponLoading,
    couponDetails
  } = (0, _store.useAppSelector)(_orderSlice.selectOrder);
  const {
    offerV2: {
      giftable = false
    }
  } = (0, _store.useAppSelector)(_offerSlice.selectOffer);
  const {
    totalPrice,
    discount: {
      applied: discountApplied
    }
  } = (0, _store.useAppSelector)(_orderSlice.selectOnlyOrder);
  const {
    couponCode
  } = couponDetails;
  const isFree = totalPrice === 0 && !discountApplied;
  (0, _react.useEffect)(() => {
    setCoupon(couponCode);
  }, [couponCode]);
  if (isFree) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_OfferStyled.StyledOfferWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("main", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FreeOffer.default, {
          onPaymentComplete: onPaymentComplete
        })
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_OfferStyled.StyledOfferWrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)("main", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_OfferStyled.StyledOfferBody, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionHeader.default, {
          center: true,
          children: t('offer.complete-purchase', 'Complete your purchase')
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_OfferStyled.StyledOfferDetailsAndCoupon, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferStyled.OfferCardWrapperStyled, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferCheckoutCard.default, {
              isRedeemGift: false
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferStyled.StyledOfferCouponWrapper, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CouponInput.default, {
              onSubmit: onCouponSubmit,
              value: coupon,
              onChange: e => setCoupon(e),
              source: "checkout",
              couponLoading: isCouponLoading,
              couponDetails: couponDetails
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutPriceBox.default, {
          isCheckout: isCheckout,
          onRedeemClick: onRedeemClick
        })]
      }), giftable && /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeliveryDetails.default, {
        giftable: giftable
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Payment.default, {
        onPaymentComplete: onPaymentComplete
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Footer.default, {})]
  });
};
var _default = exports.default = Offer;